import React from 'react';
import PropTypes from 'prop-types';

export default class ArticlesList extends React.Component {
    render() {
        const {key, className, articles} = this.props;

        return <section className={`articles ${className}`} key={`${key}-articles`}>
            <div className="wrapper">
                <div className="section-content">
                    {articles && articles.map(article =>
                        <div className="article" key={`${key}-articles-${article.id}`}>
                            <h5 dangerouslySetInnerHTML={{__html: article.postType}}/>
                            {article.thumb && <p className="img">
                                <a href={article.href}>
                                    <img src={article.thumb} className="lazyload" alt={article.title}/>
                                </a>
                            </p>}
                            <p className="by" dangerouslySetInnerHTML={{__html: article.author}}/>
                            <p className="title">
                                <a href={article.href} dangerouslySetInnerHTML={{__html: article.title}}/>
                            </p>
                            <p dangerouslySetInnerHTML={{__html: article.description}}/>
                        </div>)}
                </div>
            </div>
        </section>;
    }
}

ArticlesList.propTypes = {
    key: PropTypes.string,
    articles: PropTypes.array.isRequired,
    className: PropTypes.string
}

ArticlesList.defaultProps = {
    key: '',
    articles: [],
    className: ''
}